import smartLifeIndex from '@/views/smartLife/smartLifeIndex.vue'

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'smartLifeIndex',
      name: 'smartLifeIndex',
      component: smartLifeIndex
    },


  ]
}
